import axios from "@/plugins/axios";

let url = "/api/v1/gshop2/collection";

export const collection = {
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
}